import { Box, Typography } from "@mui/material";
import { DropzoneOptions, useDropzone } from "react-dropzone";
import { Trans, useTranslation } from "react-i18next";
import { MAX_UPLOAD_FILE_SIZE_IMPORT } from "../../constants/form";
import InfoPopper from "../popper/InfoPopper";
import { common, input } from "../../i18n";

interface Props {
  dropZoneOptions: DropzoneOptions;
}

export const UploadFileWithOutPreview = ({ dropZoneOptions }: Props) => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...dropZoneOptions,
    // onDropRejected(fileRejections, event) {
    //   if (fileRejections[0].errors[0].code === "file-too-large") {
    //     return alertService.error(
    //       t("maximum-file-size", {
    //         size: (MAX_UPLOAD_FILE_SIZE_IMPORT / 1e6).toFixed(0),
    //       })
    //     );
    //   } else {
    //     return alertService.error(t("Invalid-File-Type"));
    //   }
    // },
  });

  return (
    <>
      <Typography
        variant="h3"
        color={"var(--dark)"}
        sx={{
          marginBottom: "8px",
          borderBlockStart: "1px",
        }}
      >
        {`${t("Evidence-File")}`}
        <InfoPopper text={t("Attachment-Description")} />
      </Typography>
      <Box
        {...getRootProps()}
        sx={{
          border: "2px dashed grey",
          borderRadius: "8px",
          padding: "16px",
          textAlign: "center",
          cursor: "pointer",
          backgroundColor: isDragActive ? "#f0f0f0" : "#fafafa",
          "&:hover": { backgroundColor: "#f0f0f0" },
        }}
      >
        <input {...getInputProps()} />
        <Box color={"var(--gray4)"}>
          <Typography variant="body1">
            <Trans
              t={t}
              i18nKey="drag-drop-or-browse"
              components={{
                span: <span style={{ color: "var(--green)" }} />,
              }}
            />
          </Typography>
          <Typography variant="body1">
            <Trans
              t={t}
              i18nKey="maximum-file-size"
              values={{
                size: (MAX_UPLOAD_FILE_SIZE_IMPORT / 1e6).toFixed(0),
              }}
            />
          </Typography>
        </Box>
      </Box>
    </>
  );
};
